import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthImage from '../images/auth/authframe.png';
import Logo from '../images/auth/logo (2).png';

const Signup = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        gender: '',
        dateOfBirth: '',
        referralCode: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value;
        // Only allow digits and enforce max length of 10 (after 234)
        if (/^\d{0,10}$/.test(value)) {
            setFormData(prev => ({
                ...prev,
                phoneNumber: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);
        
        const payload = {
            phone_number: `234${formData.phoneNumber}`,
            email: formData.email,
            first_name: formData.firstName,
            last_name: formData.lastName,
            date_of_birth: formData.dateOfBirth,
            gender: formData.gender.toLowerCase(),
            channel: "phone_number",
            referral_code: formData.referralCode.trim() === '' ? null : formData.referralCode.trim()
        };

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Accept", "application/json");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payload),
                redirect: "follow"
            };

            const response = await fetch("https://devapi.quickcare.ng/api/v1/user/signup", requestOptions);
            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Signup failed');
            }

            console.log("Signup successful:", result);
             
            // Save verification_id to localStorage
            if (result.data?.verification_id) {
                localStorage.setItem('quickcare-verification-id', result.data.verification_id);
            }
            
            // Wait 1 second before redirecting
            setTimeout(() => {
                navigate('/signup/otp');
            }, 1000);
            
        } catch (error) {
            console.error("Signup error:", error);
            setError(error.message || 'An error occurred during signup');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col md:flex-row bg-white instrument-sans-normal">
            {/* Left side - Form */}
            <div className="w-full md:w-1/2 flex items-center justify-center p-4 md:p-8 lg:p-12">
                <div className="w-full max-w-md space-y-8">
                    <div className="">
                        <img src={Logo} alt="Company Logo" className='w-[196px] h-[49px]'/>
                        <h2 className="mt-6 text-2xl instrument-sans-semibold text-gray-700">
                            Create Account
                        </h2>
                    </div>
                    
                    {error && (
                        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                            <span className="block sm:inline">{error}</span>
                        </div>
                    )}
                    
                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="firstName" 
                                className="block text-sm font-medium text-[#8B8D8C]"
                                >
                                    First name
                                </label>
                                <input
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    placeholder="Enter your first name"
                                    required
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                    disabled={isSubmitting}
                                />
                            </div>
                            
                            <div>
                                <label htmlFor="lastName"
                                 className="block text-sm font-medium text-[#8B8D8C]"
                                 >
                                    Last name
                                </label>
                                <input
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    placeholder="Enter your last name"
                                    required
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                        
                        <div>
                            <label htmlFor="email"
                             className="block text-sm font-medium text-[#8B8D8C]"
                            >
                                Email Address
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter your email address"
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                disabled={isSubmitting}
                            />
                        </div>
                        
                        <div>
                            <label htmlFor="phoneNumber" 
                            className="block text-sm font-medium text-[#8B8D8C]"
                            >
                                Phone Number
                            </label>
                            <div className="mt-1 flex rounded-md shadow-sm">
                                <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                                    234
                                </span>
                                <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="tel"
                                    value={formData.phoneNumber}
                                    onChange={handlePhoneNumberChange}
                                    placeholder="8012345678"
                                    maxLength="10"
                                    required
                                    className="flex-1 block w-full rounded-none rounded-r-md border border-gray-300 py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                    disabled={isSubmitting}
                                />
                            </div>
                            <p className="mt-1 text-xs text-gray-500">
                                Enter 10 digits 
                            </p>
                        </div>

                        <div>
                            <label htmlFor="dateOfBirth" 
                            className="block text-sm font-medium text-[#8B8D8C]"
                            >
                                Date of Birth
                            </label>
                            <input
                                id="dateOfBirth"
                                name="dateOfBirth"
                                type="date"
                                value={formData.dateOfBirth}
                                onChange={handleChange}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                disabled={isSubmitting}
                            />
                        </div>
                        
                        <div>
                            <label htmlFor="gender" 
                            className="block text-sm font-medium text-[#8B8D8C]"
                            >
                                Gender
                            </label>
                            <select
                                id="gender"
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                disabled={isSubmitting}
                            >
                                <option value="" disabled>Select your gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>

                        {/* Referral Code Field - Optional */}
                        <div>
                            <label htmlFor="referralCode" 
                            className="block text-sm font-medium text-[#8B8D8C]"
                            >
                                Referral Code <span className="text-xs text-gray-400 font-normal">(Optional)</span>
                            </label>
                            <input
                                id="referralCode"
                                name="referralCode"
                                type="text"
                                value={formData.referralCode}
                                onChange={handleChange}
                                placeholder="Enter referral code if you have one"
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                disabled={isSubmitting}
                            />
                            <p className="mt-1 text-xs text-gray-500">
                                Have a referral code? Enter it here to get benefits
                            </p>
                        </div>
                        
                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#069125] hover:bg-[#057a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-75"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Submitting...' : 'Create Account'}
                            </button>
                        </div>

                        <div className="flex items-center justify-between">
                            <div className="text-sm">
                                <a href="/login" 
                                className="font-medium text-[#8B8D8C]"
                                >
                                    Already have an account? 
                                    <span className='text-[#45B139] ml-1'>
                                        Login
                                    </span>
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Right side - Background Image (hidden on mobile) */}
            <div 
                className="hidden md:block md:w-1/2 bg-indigo-50 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${AuthImage})` }}
            >
                {/* Optional: You can add content over the background image here if needed */}
            </div>
        </div>
    );
};

export default Signup;